// The page and section loaders. `logo` (the default) pulses the Noxus mark; `blocks` is the row
// of three pulsing blocks the layouts and the triggers modal show while they load.
export const NoxusLoadingPulse = ({
  size = 25,
  variant = "logo",
}: {
  size?: number;
  variant?: "logo" | "blocks";
}) => {
  if (variant === "blocks") {
    return (
      <>
        <style>
          {`
          @keyframes pulse {
            0%, 100% { background-color: var(--accent);  opacity: 0.8;}
            10% { background-color: var(--accent); opacity: 1; }
            20% { background-color: var(--accent); }
            30% { background-color: var(--accent);  opacity: 1;}
          }
        `}
        </style>
        <div className="flex gap-0.5">
          {[0, 1, 2].map((index) => (
            <div
              style={{
                height: "1.5rem",
                width: "1.5rem",
                borderRadius: "0.5rem",
                animationDelay: `${index * 0.1}s`,
              }}
              className="bg-accent animate-pulse"
              key={index}
            />
          ))}
        </div>
      </>
    );
  }
  return (
    <>
      <style jsx>{`
        @keyframes rotate-scale {
          0% {
            transform: rotate(0deg) scale(1);
            opacity: 0.75;
          }
          50% {
            transform: rotate(0) scale(1.2);
            opacity: 1;
          }
          100% {
            transform: rotate(0) scale(1);
            opacity: 0.75;
          }
        }
        .noxus-pulse {
          animation: rotate-scale 1s infinite ease;
        }
      `}</style>
      <div className="transition-opacity duration-1000 ease-in-out">
        <img
          src="https://storage.googleapis.com/image-storage-spot-manual/app/sidenav/noxus-o.svg"
          alt="Noxus logo"
          width={size}
          height={size}
          className="noxus-pulse dark:invert dark:brightness-0"
        />
      </div>
    </>
  );
};
